var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M473.655,423.724H38.345C17.167,423.724,0,406.557,0,385.379V126.621 c0-21.177,17.167-38.345,38.345-38.345h435.31c21.177,0,38.345,17.167,38.345,38.345V385.38 C512,406.557,494.833,423.724,473.655,423.724z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M479.172,88.676L256,234.893L32.828,88.676C19.454,90.604,8.316,99.43,3.132,111.434L223.784,256 L3.132,400.566c5.184,12.004,16.323,20.83,29.697,22.758L256,277.107l223.172,146.216c13.374-1.928,24.512-10.753,29.697-22.758 L288.216,256L508.87,111.434C503.684,99.43,492.546,90.604,479.172,88.676z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M282.557,126.86c0,0-2.795-4.193-6.988-1.398c0,0,4.849,3.495,1.572,7.164 c-3.467,3.883-8.233,0.085-8.532-2.698c1.271-0.097,2.276-1.148,2.276-2.444c0-1.361-1.102-2.463-2.463-2.463 c-1.361,0-2.463,1.102-2.463,2.463c0,1.062,0.676,1.959,1.618,2.305c-0.601,2.382-6.849,4.205-8.65,0.26 c-2.028-4.441,1.18-8.212,5.504-7.688c0,0-0.83-5.503-6.682-3.189c0,0,2.446-6.29-1.747-10.483 c-4.193,4.193-1.747,10.483-1.747,10.483c-5.853-2.315-6.682,3.189-6.682,3.189c4.324-0.524,7.531,3.245,5.504,7.688 c-1.801,3.945-8.049,2.122-8.65-0.26c0.942-0.345,1.618-1.242,1.618-2.305c0-1.361-1.102-2.463-2.463-2.463 s-2.463,1.102-2.463,2.463c0,1.297,1.005,2.347,2.276,2.444c-0.299,2.783-5.066,6.581-8.532,2.698 c-3.276-3.669,1.572-7.164,1.572-7.164c-4.193-2.795-6.988,1.398-6.988,1.398c-1.398-5.591-6.988-4.193-6.988-4.193 c5.591,6.988,9.702,21.404,9.702,21.404h47.687c0,0,4.11-14.415,9.702-21.404C289.545,122.667,283.954,121.269,282.557,126.86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M279.843,144.071c-7.714-2.719-15.779-4.078-23.843-4.078s-16.129,1.359-23.843,4.078 C219.65,198.87,256,213.517,256,213.517S292.35,198.87,279.843,144.071z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M238.561,163.567c0,0-1.146-0.216-2.143,0.582c0,0-0.349-1.378,1.444-1.71 C239.657,162.105,238.561,163.567,238.561,163.567z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M237.181,161.824c0,0-0.908-0.732-2.163-0.5c0,0,0.344-1.379,2.082-0.824 C238.838,161.054,237.181,161.824,237.181,161.824z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M237.932,162.538c0,0-1.252-0.216-2.342,0.582c0,0-0.381-1.378,1.579-1.71 C239.129,161.077,237.932,162.538,237.932,162.538z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M259.623,166.199c0,0-1.165,0.055-1.95,1.062c0,0-0.658-1.26,1.01-1.998 C260.35,164.524,259.623,166.199,259.623,166.199z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M257.914,164.697c0,0-1.053-0.502-2.22,0.014c0,0,0.015-1.422,1.834-1.284 C259.347,163.565,257.914,164.697,257.914,164.697z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M258.773,165.343c0,0-1.269,0.079-2.144,1.107c0,0-0.69-1.252,1.141-2.029 C259.601,163.644,258.773,165.343,258.773,165.343z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M272.931,166.919c0,0-0.436,0-1.217,0.735c0,0-0.559-1.25,1.087-1.864 C274.449,165.176,272.931,166.919,272.931,166.919z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M272.095,165.202c0,0-0.983-0.544-2.135-0.116c0,0,0.097-1.366,1.838-1.129 C273.539,164.196,272.095,165.202,272.095,165.202z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M272.883,165.873c0,0-1.225,0.003-2.125,0.94c0,0-0.59-1.245,1.215-1.886 C273.778,164.287,272.883,165.873,272.883,165.873z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M236.644,154.919c0,0-1.053-0.7-2.387-0.329c0,0,0.238-1.519,2.17-1.091 C238.36,153.927,236.644,154.919,236.644,154.919z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M236.557,152.297c0,0-0.68-1.069-2.131-1.163c0,0,0.939-1.441,2.588-0.335 C238.664,151.903,236.557,152.297,236.557,152.297z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M236.563,153.689c0,0-1.11-0.82-2.577-0.518c0,0,0.33-1.603,2.408-1.011 C238.473,152.754,236.563,153.689,236.563,153.689z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M269.568,158.485c1.844,0.05,4.035-0.681,4.384-2.591c0.401-2.195-1.479-3.305-4.002-3.206 c-1.842,0.073-6.507,1.131-9.848,1.013c-3.305-0.116-3.395-3.386,1.611-3.039c7.424,0.515,8.603-0.448,8.603-0.448 c-3.986,0.747-5.58-0.648-9.815-0.648c-4.235,0-5.048,2.933-3.338,4.534c1.916,1.794,8.868,0.598,10.712,0.249 c1.844-0.349,4.182-0.367,4.367,0.93c0.165,1.163-2.923,1.1-5.111,1.016c-3.482-0.134-8.55,0.811-13.058,1.044 c-3.756,0.194-4.279-0.865-5.134-1.95c0.2-0.361,0.314-0.764,0.314-1.19c0-0.215-0.034-0.423-0.088-0.625 c0.284-0.311,0.582-0.809,0.718-1.618c0,0-0.961-0.169-1.687,0.198c-0.582-0.459-1.353-0.746-2.206-0.746 c-0.854,0-1.624,0.287-2.206,0.746c-0.726-0.366-1.687-0.198-1.687-0.198c0.137,0.81,0.435,1.306,0.718,1.618 c-0.054,0.201-0.088,0.408-0.088,0.625c0,0.782,0.376,1.489,0.983,1.996c0.292,0.245,0.51,0.567,0.584,0.941l0.105,0.531 c0.046,0.233,0.196,0.415,0.391,0.526c-3.096-0.319-4.562-2.265-5.314-3.347c-0.849-1.22-1.378-3.919-2.674-4.218l-0.764,4.07 c0,0,1.637,3.786,4.683,5.331c3.438,1.743,4.086,1.794,5.215,2.292c0.132,0.598-2.126,0.963-4.418,0.499 c-1.6-0.324-3.756-2.648-4.984-2.482l1.431,3.179c3.886,2.458,7.283,2.51,10.197,1.993c2.059-0.365,2.842-2.042,2.978-2.76 c0.841-0.156,1.757-0.33,4.595-1.027c1.188-0.292,2.557-0.446,3.919-0.51c0.384,0.876,1.262,1.998,4.285,2.104 c0,0,0.73,1.163-1.76,0.93c-2.492-0.233-3.13-1.009-4.593-0.843l1.304,3.102c0,0,3.189-1.096,7.108-0.697c0,0,0.73,0.2,1.163-0.431 c0.431-0.631,0.233-0.996-0.167-1.561c-0.224-0.318-0.354-1.348-0.424-2.191c1.436,0.361,5.841-0.533,7.433-0.399 c1.594,0.132,1.827,1.993,1.461,2.624c-0.365,0.631-3.703,0.092-3.703,0.092l1.121,3.064c0,0,0.337-0.162,1.187-0.963 c0.692-0.651,3.521-0.431,3.521-0.93v-5.676c0-0.269-0.234-0.479-0.502-0.456C270.846,159.526,269.568,158.485,269.568,158.485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M244.679,156.468c0.094,0.183,0.163,0.382,0.201,0.593l0.094,0.531 c0.033,0.186,0.18,0.321,0.35,0.321h1.448c0.17,0,0.317-0.135,0.35-0.321l0.094-0.531c0.038-0.211,0.107-0.409,0.201-0.593H244.679z "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M246.047,157.517c-0.334,0-0.595,0.041-0.559,0.505l0.135,1.985 c0.023,0.303,0.206,0.534,0.424,0.534c0.217,0,0.402-0.231,0.424-0.534l0.135-1.985 C246.641,157.558,246.38,157.517,246.047,157.517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M241.736,183.171c0,0-0.935-0.177-1.748,0.474c0,0-0.285-1.124,1.178-1.396 C242.631,181.98,241.736,183.171,241.736,183.171z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M240.61,181.75c0,0-0.74-0.597-1.764-0.408c0,0,0.28-1.126,1.698-0.673 C241.962,181.121,240.61,181.75,240.61,181.75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M241.224,182.332c0,0-1.022-0.177-1.91,0.474c0,0-0.311-1.124,1.288-1.396 C242.2,181.14,241.224,182.332,241.224,182.332z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M258.916,185.319c0,0-0.95,0.045-1.59,0.865c0,0-0.537-1.028,0.824-1.63 C259.512,183.953,258.916,185.319,258.916,185.319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M257.523,184.094c0,0-0.858-0.409-1.811,0.011c0,0,0.012-1.16,1.496-1.047 C258.692,183.17,257.523,184.094,257.523,184.094z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M258.222,184.62c0,0-1.035,0.065-1.749,0.903c0,0-0.563-1.022,0.93-1.655 C258.898,183.234,258.222,184.62,258.222,184.62z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M269.771,185.905c0,0-0.355,0-0.993,0.599c0,0-0.457-1.02,0.887-1.519 C271.009,184.484,269.771,185.905,269.771,185.905z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M269.09,184.505c0,0-0.802-0.444-1.742-0.094c0,0,0.079-1.114,1.5-0.92 C270.268,183.684,269.09,184.505,269.09,184.505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M269.732,185.052c0,0-0.999,0.002-1.734,0.767c0,0-0.482-1.015,0.991-1.538 C270.462,183.758,269.732,185.052,269.732,185.052z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M240.172,176.117c0,0-0.858-0.57-1.947-0.268c0,0,0.194-1.24,1.771-0.89 C241.572,175.309,240.172,176.117,240.172,176.117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M240.102,173.978c0,0-0.555-0.873-1.738-0.949c0,0,0.766-1.175,2.111-0.274 C241.82,173.657,240.102,173.978,240.102,173.978z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M240.107,175.114c0,0-0.906-0.669-2.102-0.422c0,0,0.269-1.308,1.964-0.824 C241.665,174.351,240.107,175.114,240.107,175.114z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M267.028,179.027c1.504,0.041,3.292-0.555,3.576-2.113c0.327-1.79-1.206-2.696-3.265-2.614 c-1.503,0.06-5.308,0.922-8.033,0.826c-2.696-0.095-2.77-2.762,1.314-2.479c6.056,0.42,7.017-0.365,7.017-0.365 c-3.251,0.609-4.552-0.529-8.007-0.529s-4.117,2.392-2.723,3.699c1.563,1.463,7.234,0.488,8.738,0.203s3.412-0.3,3.563,0.759 c0.136,0.948-2.385,0.897-4.169,0.829c-2.841-0.109-6.974,0.662-10.652,0.851c-3.064,0.158-3.49-0.706-4.188-1.59 c0.163-0.295,0.256-0.622,0.256-0.97c0-0.175-0.029-0.344-0.073-0.509c0.232-0.254,0.474-0.66,0.586-1.32 c0,0-0.785-0.138-1.376,0.161c-0.474-0.374-1.103-0.608-1.8-0.608s-1.325,0.234-1.8,0.608c-0.591-0.299-1.376-0.161-1.376-0.161 c0.111,0.66,0.354,1.066,0.586,1.32c-0.044,0.164-0.073,0.333-0.073,0.509c0,0.638,0.308,1.215,0.802,1.628 c0.238,0.2,0.416,0.462,0.476,0.768l0.086,0.434c0.038,0.19,0.16,0.338,0.319,0.429c-2.526-0.26-3.721-1.847-4.334-2.73 c-0.692-0.995-1.124-3.197-2.182-3.441l-0.623,3.319c0,0,1.336,3.089,3.82,4.349c2.804,1.422,3.332,1.463,4.254,1.869 c0.108,0.488-1.734,0.786-3.604,0.406c-1.305-0.265-3.063-2.159-4.066-2.025l1.167,2.593c3.17,2.005,5.941,2.047,8.318,1.625 c1.679-0.298,2.318-1.665,2.429-2.251c0.685-0.127,1.432-0.269,3.748-0.838c0.97-0.238,2.086-0.364,3.198-0.416 c0.313,0.715,1.03,1.631,3.495,1.716c0,0,0.596,0.948-1.436,0.758c-2.033-0.19-2.553-0.823-3.746-0.687l1.064,2.53 c0,0,2.601-0.894,5.799-0.569c0,0,0.596,0.162,0.948-0.352c0.352-0.515,0.19-0.813-0.136-1.273c-0.183-0.259-0.288-1.1-0.346-1.788 c1.171,0.295,4.765-0.435,6.062-0.327c1.301,0.108,1.49,1.625,1.192,2.141c-0.298,0.515-3.021,0.075-3.021,0.075l0.915,2.499 c0,0,0.275-0.132,0.969-0.786c0.564-0.531,2.872-0.352,2.872-0.758v-4.63c0-0.22-0.191-0.391-0.409-0.372 C268.071,179.875,267.028,179.027,267.028,179.027z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M246.727,177.38c0.076,0.15,0.134,0.312,0.163,0.483l0.076,0.434 c0.026,0.152,0.147,0.262,0.285,0.262h1.181c0.138,0,0.258-0.11,0.285-0.262l0.076-0.434c0.031-0.171,0.087-0.334,0.163-0.483 H246.727z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M247.842,178.237c-0.273,0-0.484,0.033-0.456,0.413l0.11,1.619c0.019,0.248,0.168,0.436,0.346,0.436 c0.179,0,0.328-0.188,0.346-0.436l0.11-1.619C248.327,178.27,248.115,178.237,247.842,178.237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M245.267,198.753c0,0-0.7-0.132-1.309,0.355c0,0-0.213-0.842,0.883-1.045 C245.937,197.86,245.267,198.753,245.267,198.753z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M244.424,197.688c0,0-0.555-0.447-1.321-0.306c0,0,0.21-0.843,1.271-0.504 C245.436,197.218,244.424,197.688,244.424,197.688z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M244.883,198.124c0,0-0.765-0.132-1.43,0.355c0,0-0.233-0.842,0.964-1.045 C245.614,197.231,244.883,198.124,244.883,198.124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M258.13,200.361c0,0-0.712,0.033-1.191,0.648c0,0-0.402-0.77,0.617-1.22 C258.575,199.338,258.13,200.361,258.13,200.361z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M257.087,199.444c0,0-0.643-0.307-1.356,0.009c0,0,0.01-0.868,1.12-0.785 C257.963,198.752,257.087,199.444,257.087,199.444z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M257.611,199.838c0,0-0.775,0.049-1.309,0.676c0,0-0.422-0.765,0.696-1.239 S257.611,199.838,257.611,199.838z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M266.259,200.8c0,0-0.266,0-0.744,0.449c0,0-0.342-0.764,0.664-1.138 C267.185,199.736,266.259,200.8,266.259,200.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M265.748,199.752c0,0-0.6-0.332-1.304-0.071c0,0,0.06-0.834,1.123-0.69 C266.631,199.136,265.748,199.752,265.748,199.752z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M266.229,200.161c0,0-0.748,0.002-1.299,0.575c0,0-0.361-0.76,0.742-1.152 S266.229,200.161,266.229,200.161z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M244.096,193.472c0,0-0.643-0.427-1.458-0.201c0,0,0.146-0.928,1.326-0.666 C245.144,192.866,244.096,193.472,244.096,193.472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M244.043,191.87c0,0-0.415-0.653-1.301-0.711c0,0,0.574-0.879,1.58-0.205 C245.33,191.629,244.043,191.87,244.043,191.87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M244.046,192.721c0,0-0.679-0.501-1.574-0.316c0,0,0.201-0.979,1.471-0.617 C245.213,192.149,244.046,192.721,244.046,192.721z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M264.204,195.649c1.126,0.031,2.465-0.416,2.678-1.582c0.245-1.341-0.903-2.018-2.444-1.958 c-1.126,0.044-3.974,0.691-6.015,0.619c-2.018-0.071-2.073-2.068,0.984-1.856c4.534,0.314,5.255-0.274,5.255-0.274 c-2.434,0.457-3.409-0.396-5.995-0.396s-3.083,1.791-2.039,2.77c1.17,1.096,5.417,0.365,6.542,0.152 c1.126-0.213,2.554-0.224,2.668,0.568c0.102,0.71-1.785,0.672-3.122,0.62c-2.127-0.082-5.221,0.495-7.976,0.638 c-2.294,0.118-2.614-0.529-3.136-1.191c0.122-0.221,0.192-0.466,0.192-0.726c0-0.131-0.021-0.258-0.054-0.381 c0.173-0.191,0.355-0.494,0.439-0.989c0,0-0.587-0.103-1.031,0.12c-0.355-0.28-0.825-0.456-1.347-0.456s-0.992,0.175-1.347,0.456 c-0.444-0.224-1.031-0.12-1.031-0.12c0.084,0.494,0.266,0.798,0.439,0.989c-0.033,0.122-0.054,0.249-0.054,0.381 c0,0.478,0.231,0.909,0.6,1.219c0.179,0.149,0.311,0.346,0.356,0.575l0.064,0.324c0.028,0.142,0.12,0.253,0.238,0.321 c-1.891-0.195-2.786-1.384-3.245-2.044c-0.519-0.745-0.842-2.393-1.633-2.577l-0.467,2.485c0,0,1.001,2.313,2.86,3.256 c2.1,1.065,2.495,1.096,3.185,1.4c0.082,0.365-1.299,0.588-2.698,0.305c-0.978-0.199-2.294-1.618-3.044-1.516l0.874,1.942 c2.374,1.501,4.448,1.533,6.228,1.217c1.258-0.223,1.736-1.247,1.818-1.685c0.513-0.095,1.073-0.202,2.806-0.628 c0.726-0.179,1.561-0.273,2.394-0.311c0.235,0.535,0.771,1.22,2.616,1.284c0,0,0.446,0.71-1.075,0.568 c-1.522-0.142-1.912-0.616-2.805-0.515l0.797,1.895c0,0,1.948-0.67,4.341-0.426c0,0,0.446,0.121,0.71-0.264 c0.264-0.385,0.142-0.609-0.102-0.953c-0.137-0.194-0.216-0.824-0.259-1.338c0.877,0.221,3.567-0.326,4.54-0.244 c0.973,0.082,1.116,1.217,0.893,1.602s-2.262,0.056-2.262,0.056l0.684,1.871c0,0,0.205-0.099,0.725-0.588 c0.423-0.397,2.151-0.264,2.151-0.568v-3.467c0-0.164-0.142-0.292-0.307-0.278C264.984,196.286,264.204,195.649,264.204,195.649z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M249.003,194.418c0.057,0.113,0.099,0.234,0.122,0.362l0.057,0.324 c0.02,0.114,0.11,0.196,0.213,0.196h0.884c0.104,0,0.193-0.083,0.213-0.196l0.057-0.324c0.023-0.128,0.065-0.25,0.122-0.362H249.003 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M249.838,195.059c-0.204,0-0.363,0.024-0.342,0.309l0.083,1.212c0.014,0.185,0.126,0.327,0.259,0.327 c0.134,0,0.245-0.141,0.259-0.327l0.083-1.212C250.201,195.083,250.042,195.059,249.838,195.059z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJe);
export default __webpack_public_path__ + "static/media/je.8c35d0f737b9b7afe56f8658b5eeb493.svg";
export { ForwardRef as ReactComponent };